import React from 'react';
import classNames from 'classnames';
import Typography from 'src/components/common/typography/Typography';
import Card from 'src/components/common/card/Card';
import './IncubatorsCard.scss';
import userImg from '../../assets/images/companylogo/YLAC.png'
import { useAppSelector } from 'src/store/hooks';
import { ProfilePicture } from '../common';
import { textFormatter } from 'src/utils';
import { useNavigate } from 'react-router-dom';
import { useGetIdentity } from 'src/hooks';
import IncubatorBadge from 'src/assets/images/svg/IncubatorBadge.svg';

function IncubatorsCard() {
    const { topUsersCompany } = useAppSelector((store) => store.socialMedia);
    const navigate = useNavigate()
    const incubatorUpdates = topUsersCompany?.updatesFromIncubators?.slice(0, 3);
    const handleRedirect = (id: string) => {
        const route = `/view-post?postId=${id}&viewAs=User`
        navigate(route)
    }

    if (incubatorUpdates?.length === 0) {
        return <></>
    }

    return (
        <Card className={classNames('incubatorsCard')}>
            <Typography as="p" variant="body-1" fontWeight="semiBold">
                Updates from Incubators
            </Typography>{' '}

            <ul className='listedView'>
                {incubatorUpdates?.map((item: any, i) => {
                    return (
                        <li key={i} onClick={() => handleRedirect(item?.post?.id)}>
                            <div className='imgBox' style={{ marginRight: '5px' }}>
                                {/* <img src={userImg} alt="img" /> */}
                                <ProfilePicture url={item?.user?.profilePic} fallback={textFormatter({ value: item?.user?.name[0] })} />
                            </div>
                            <div className='contentBox'>
                                <Typography as="p" variant="body-1" fontWeight="semiBold">
                                    {item?.user?.name} <img style= {{ marginLeft: "4px", height: "20px", width: "20px", marginBottom: "4px" }} src={IncubatorBadge} alt="Incubator" /> {item?.post?.title ? `: ${item?.post?.title}` : ''}
                                </Typography>{' '}
                                <Typography as="p" variant="body-2" fontWeight="regular">
                                    {item?.post?.text}
                                </Typography>
                            </div>
                        </li>
                    )
                })}

            </ul>

        </Card>
    )
}

export default IncubatorsCard
